import { render, staticRenderFns } from "./OrderWait.vue?vue&type=template&id=dc5d7044&scoped=true"
import script from "./OrderWait.vue?vue&type=script&lang=js"
export * from "./OrderWait.vue?vue&type=script&lang=js"
import style0 from "./OrderWait.vue?vue&type=style&index=0&id=dc5d7044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5d7044",
  null
  
)

export default component.exports